module.exports = __webpack_public_path__ + "static/shuttleid-privacy-policy-updated-july-2023-57e89cfb858b2758e218bb8a0aee1fbb.pdf";